import React from 'react';
import styled from 'styled-components';
import { Col, Ic3Dots, Text } from 'basic-ui-lib';
import IcFolder from 'modules/media/assets/icons/IcFolder';
import MenuAction from 'basic-ui-lib/components/MenuTabelAction';
import { IMediaItem } from 'modules/media/interfaces/api';
import EditNameModal from 'basic-ui-lib/components/Modal/EditNameModal';
import ModalConfirm from 'widgets/ModalConfirm';
import colors from 'basic-ui-lib/constants/colors';
import { useMediaMoreAction } from 'modules/media/services/hooks/useMediaMoreAction';
import { useMediaQuery } from 'react-responsive';
import MoveToStoresModal from '../MoveToStoreModal';
import MoveToFolderModal from '../MoveToFolderModal';
import useGetAllFoldersInStore from 'modules/media/services/hooks/useGetAllFolderInStore';

interface FolderCardProps {
  item: IMediaItem;
  onClick: () => void;
  length?: number;
  currentPath: string;
  onSuccess: (currentPath: string) => void;
  storeId?: string;
}
export const FolderCard = ({
  item,
  onClick,
  length,
  currentPath,
  onSuccess,
  storeId,
}: FolderCardProps) => {
  const [, mutate] = useGetAllFoldersInStore(storeId || '', true);
  const {
    getListMenu,
    handleMenuClick,
    modalConfirmRef,
    editNameModalRef,
    moveToStoresModalRef,
    moveToFolderModalRef,
  } = useMediaMoreAction({ currentPath, onSuccess, deleteSuccess: mutate, storeId });
  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <>
      <Container
        {...(isMobile ? { onClick: onClick } : { onDoubleClick: onClick })}
      >
        <MoreButton
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}
        >
          <MenuAction
            listMenu={getListMenu(item)}
            onClick={(menuItem) => handleMenuClick(menuItem, item)}
          >
            <Ic3Dots width={24} height={24} />
          </MenuAction>
        </MoreButton>
        <Content>
          <IcFolder />
        </Content>
        <Col gap={4} width='100%' alignItems='center'>
          <Text ellipsis content_2 medium>
            {item.name}
          </Text>
          <Text caption_3 regular color='neutral.text.3'>
            {length} items
          </Text>
        </Col>
      </Container>
      <ModalConfirm ref={modalConfirmRef} />
      <EditNameModal ref={editNameModalRef} />
      <MoveToStoresModal ref={moveToStoresModalRef} />
      <MoveToFolderModal ref={moveToFolderModalRef} storeId={storeId} onSuccess={onSuccess} currentPath={currentPath} />
    </>
  );
};

const MoreButton = styled.div`
  position: absolute;
  top: -4px;
  right: -4px;
  z-index: 2;
  opacity: 0;
  visibility: hidden;
  transition:
    opacity 0.2s,
    visibility 0.2s;

  width: 40px;
  height: 40px;

  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  background-color: ${colors.neutral.bg[1]};

  &:hover {
    cursor: pointer;
  }

  @media (max-width: 768px) {
    opacity: 1;
    visibility: visible;
    top: 4px;
    right: 4px;
    width: 28px;
    height: 28px;
    background-color: ${colors.neutral.bg[2]};
  }
`;

const Container = styled.div`
  cursor: pointer;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  position: relative;
  user-select: none;

  &:hover ${MoreButton} {
    opacity: 1;
    visibility: visible;
  }

  @media (max-width: 768px) {
    background: ${colors.neutral.bg[1]};
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    padding-bottom: 8px;

    .content_2 {
      font-size: 14px;
    }
  }
`;

const Content = styled.div`
  width: 131px;
  height: 131px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    height: 95px;
  }
`;
